import Marionette from 'backbone.marionette';
import viewMixins from './core/internal/viewMixins';

export default Marionette.ItemView.extend(viewMixins(Marionette.ItemView));
